import React from 'react'
import { useTranslation } from 'react-i18next'

import { Col } from '../../../../../../packages/kiti/components/structure/Grid'
import CheckboxInput from '../../../../../../components/form/CheckboxInput'
import FormItem from '../../../../../../packages/kiti/components/form/form/FormItem'

const EditWidgetForm = () => {
  const { t } = useTranslation('common')

  return (
    <>
      <Col width="100%">
        <FormItem
          label={t('widgets.invertPerspective')}
          path={['data', 'invertPerspective']}
          Input={CheckboxInput}
          ignoreLabel
        />
      </Col>
    </>
  )
}

export default EditWidgetForm
